import React, { useState } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import { Phase as PhaseType, Task } from '../types';
import TaskCard from './TaskCard';
import TaskForm from './TaskForm';

interface PhaseProps {
  phase: PhaseType;
  tasks: Task[];
  streamId: string;
  onAddTask: (task: Partial<Task>) => void;
  onDeleteTask?: (taskId: string) => void;
  onUpdateTask?: (taskId: string, updates: Partial<Task>) => void;
}

const Phase: React.FC<PhaseProps> = ({ phase, tasks, streamId, onAddTask, onDeleteTask, onUpdateTask }) => {
  const [showForm, setShowForm] = useState(false);
  
  // Only allow task creation in "To Do" phase
  const isToDoPhase = phase.name.toLowerCase() === 'to do';

  const handleAddTask = (task: Partial<Task>) => {
    onAddTask(task);
    setShowForm(false);
  };

  return (
    <div className="phase">
      <div className="phase-title">{phase.name}</div>
      <Droppable droppableId={phase.id}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`task-list ${snapshot.isDraggingOver ? 'drag-over' : ''}`}
          >
            {tasks.map((task, index) => (
              <TaskCard
                key={task.id}
                task={task}
                index={index}
                phase={phase}
                onDeleteTask={onDeleteTask}
                onUpdateTask={onUpdateTask}
              />
            ))}
            {provided.placeholder}
            
            {isToDoPhase && (
              showForm ? (
                <TaskForm
                  onSubmit={handleAddTask}
                  onCancel={() => setShowForm(false)}
                  streamId={streamId}
                  phaseId={phase.id}
                />
              ) : (
                <button 
                  className="add-task-btn"
                  onClick={() => setShowForm(true)}
                >
                  + Add a task
                </button>
              )
            )}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default Phase;